import type { InterludeTypes } from "@/interlude";
import { interlude } from "@/interlude";

export type ConversionActions = InterludeTypes["ConversionActionsResponse"];
export type ConversionActionsAccount =
  InterludeTypes["ConversionActionsAccount"];
export type ConversionActionsItem = InterludeTypes["ConversionActionsItem"];

/**
 * Accounts with their conversion actions, for the Add Conversion modal
 * cascading pickers.
 */
export function useConversionActions(orgUuid: string) {
  return interlude.googleAds.useGetConversionActions({
    params: {
      orgUuid,
    },
  });
}
